import { Button } from "@/components/ui/button"

interface AnswerButtonProps {
  showAnswerButton: boolean
  onClick: () => void
}

const AnswerButton = ({ showAnswerButton, onClick }: AnswerButtonProps) => {
  return showAnswerButton ? (
    <div className="fixed bottom-0 left-0 z-10 mx-auto w-full max-w-[800px] bg-white p-4 md:static md:p-3 md:text-center">
      <Button
        className="w-full rounded-[8px] bg-orange-500 p-3 text-[14px] font-bold text-white transition duration-200 hover:bg-orange-600 disabled:bg-neutral-200 disabled:text-neutral-500 md:max-w-[200px]"
        onClick={onClick}
      >
        Mostrar respuesta
      </Button>
    </div>
  ) : null
}

export default AnswerButton
